import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center',
  action,
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div
      className={`flex flex-col gap-4 ${
        isCenter
          ? 'items-center text-center'
          : 'items-start sm:flex-row sm:items-end sm:justify-between'
      }`}
    >
      <div className={isCenter ? 'max-w-2xl' : 'max-w-xl'}>
        {eyebrow && <span className="eyebrow mb-3">{eyebrow}</span>}
        <h2 className="text-3xl sm:text-4xl">{title}</h2>
        {description && (
          <p className="mt-3 text-base leading-relaxed text-brand-900/65">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
